module.exports = __webpack_public_path__ + "img/test-tracking-button.3dd6edc9.png";